<template>
  <div style="padding: 1vw">
    <div style="display: flex; justify-content: space-between; align-items: flex-end; padding: 0 1vw">
      <div class="pageTitle">
        <h3 class="fw-bold" style="color: #000; font-size: 1.8rem">
          접속 계정 관리
        </h3>
        <span class="pageDesc">
          서티라이프 임직원 중 운영페이지에 접근할 멤버를 등록합니다.
        </span>
      </div>
      <!-- 운영자 계정 추가·수정·삭제·초기화는 서버가 ops.operator.manage 지정자만 받음(@PermStrict) — 없으면 버튼을 숨김(10-30) -->
      <div v-if="canOperator" style="display: flex; align-items: center;">
        <button
          class="btn btn-primary"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#certiAccInfoWModal"
        >
          등록하기
        </button>
      </div>
    </div>
    <div class="filterWrap" style="">
      <div />
      <div class="searchinputbox">
        <select class="search-select" v-model="rowsPerPage" @change="handleRowsPerPage">
          <option :value="10">10개씩 보기</option>
          <option :value="20">20개씩 보기</option>
          <option :value="50">50개씩 보기</option>
        </select>
      </div>
    </div>
    <div class="container-wrapper">
      <a-table 
        class="ant-table-striped"
        size="small"
        v-if="responseData"
        :columns="columns"
        :data-source="responseData"
        :pagination="false"
        @resizeColumn="handleResizeColumn"
      >
        <template #emptyText>
          <div class="noResult">검색 결과가 없습니다.</div>
        </template>
      </a-table>
      <pagination 
        :page-info="paginationData"
        page-name="CertificateList"
        @change-page="paginationHandler"
      />
    </div>
   
    <!-- 초기화 모달 -->
    <div
      class="modal fade"
      id="resetyesno"
      tabindex="-1"
      aria-labelledby="resetModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="justify-content: center !important"
      >
        <div
          class="modal-content"
          style="width: 70% !important; padding-top: 0.5vw"
        >
          <div class="modal-body" style="display: flex; flex-direction: column">
            <div style="text-align: center; padding-top: 1rem">
              <h4>비밀번호 초기화</h4>
              <h6>임시 비밀번호는 사용자 아이디와 동일합니다.</h6>
              <h6>초기화하시겠습니까?</h6>
            </div>
            <div style="display: flex; justify-content: center; margin-top: 2rem">
              <button
                style="margin-right: 1vw;"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
              취소
              </button>
              <button
                type="button"
                class="btn btn-warning"
                @click="resetPassword()"
              >
              초기화
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 삭제 모달 -->
    <div
      class="modal fade"
      id="deleteyesno"
      tabindex="-1"
      aria-labelledby="resetModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="justify-content: center !important"
      >
        <div
          class="modal-content"
          style="width: 70% !important; padding-top: 0.5vw"
        >
          <div class="modal-body" style="display: flex; flex-direction: column">
            <div style="text-align: center; padding-top: 1rem">
              <h4>계정 삭제</h4>
              <h6>계정을 삭제하시겠습니까?</h6>
            </div>
            <!-- 운영자 계정 삭제 사유·인사 근거(계약 PERMISSIONS 6 · CI-13, W6 A6) — 선택, 적으면 보냄 -->
            <div style="display: flex; flex-direction: column; gap: 8px; margin-top: 1rem">
              <select v-model="deleteReasonCode" class="form-select form-select-sm">
                <option value="">사유(선택)</option>
                <option v-for="r in STAFF_REASONS" :key="r.value" :value="r.value">{{ r.label }}</option>
              </select>
              <input v-model="deleteHrRef" type="text" class="form-control form-control-sm" placeholder="인사 근거(선택) — 결재·발령 번호 등" maxlength="100" />
            </div>
            <div style="display: flex; justify-content: center; margin-top: 2rem">
              <button
                style="margin-right: 1vw;"
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
              취소
              </button>
              <button
                type="button"
                class="btn btn-warning"
                @click="deleteAccount()"
              >
              삭제
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<CertiAccInfoW/>
<CertiAccInfoR :data="accountDetailData"/>
<CertiAccInfoM :data="accountDetailData"/>
<!-- 2차 인증 창. 내 계정 행은 상태·예외·초기화가 막힘(D-56·D-57), 본인 수단은 상단 「내 계정 보안」 -->
<account-security-modal :account="securityAccount" @close="securityAccount = null" />
</template>
<script>

import CertiAccInfoR from "@/views/components/CertiAccInfoR.vue";
import CertiAccInfoW from "@/views/components/CertiAccInfoW.vue";
import CertiAccInfoM from "@/views/components/CertiAccInfoM.vue";
import { openDialog, phoneNumberFormatter } from "../utils/utils";
import Pagination from "@/views/components/Pagination.vue";
import AccountSecurityModal from "@/views/components/AccountSecurityModal.vue";
import { STAFF_REASONS, staffReasonFields } from "@/utils/accountRows";
import { canNow } from "@/utils/perm";


export default {
  name: "certiAccManage",
  components: {
    CertiAccInfoR,
    CertiAccInfoW,
    CertiAccInfoM,
    Pagination,
    AccountSecurityModal,
  },
  data() {
    return {
      STAFF_REASONS,
      deleteReasonCode: "", // 삭제 사유(LEAVE 등, CI-13)
      deleteHrRef: "", // 인사 근거
      condition: "", // 검색 필터
      // 목록 받아오는 변수
      responseData: [], 

      selectedAccount: "", // 선택한 계정 고유 id
      accountDetailData: {}, // 계정 상세정보 데이터
      securityAccount: null, // 「2차 인증」 창을 연 행

      // 페이지네이션 관련 변수
      listSize: 0,
      rowsPerPage: 10, // Default, can be changed by the user
      paginationData: {
        currentPage: 1, 
        totalPages: 0,
      },
      columns: [
        { key: 'name', title: '이름', dataIndex: 'name', align: 'center', },
        { key: 'username', title: '아이디', dataIndex: 'username', align: 'center', },
        {
          key: 'mobile',
          title: '휴대폰 번호',
          dataIndex: 'mobile',
          align: 'center',
          
          customRender: ({ record }) => this.phoneNumberFormatter(record.mobile)
        },
        {
          key: 'reset',
          title: '비밀번호',
          dataIndex: 'reset',
          align: 'center',
          
          customRender: ({ record }) => (
            <div
              style="display: flex; gap: 8px; justify-content: center;"
            >
              {this.canOperator ? (
                <button
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#resetyesno"
                  class="certi-custom-btn"
                  onClick={() => this.selectAccount(record._id)}
                >
                  초기화
                </button>
              ) : '-'}
            </div>

          )
        },
        {
          key: 'manage',
          title: '관리',
          dataIndex: 'manage',
          align: 'center',
          customRender: ({ record }) => (
            <div
              style="display: flex; gap: 8px; justify-content: center;"
            >
              {this.canOperator && (
                <div
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#certiAccInfoMModal"
                  class="certi-custom-btn"
                  onClick={() => this.getAccountDetail(record._id)}
                >
                  수정
                </div>
              )}
              {this.canOperator && (
                <div
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteyesno"
                  class="certi-custom-btn"
                  onClick={() => this.selectAccount(record._id)}
                >
                  삭제
                </div>
              )}
              <div
                type="button"
                class="certi-custom-btn"
                style="white-space: nowrap"
                onClick={() => {
                  this.securityAccount = record;
                }}
              >
                2차 인증
              </div>
            </div>
          )
        },
      ],
    };
  },
  
  async mounted() {
    const obj = {};
    obj.page = this.paginationData.currentPage;
    this.paginationHandler(obj);
  },
  computed: {
    canOperator() {
      return canNow(this.$store.state.introspect, "ops.operator.manage");
    },
  },
  methods: {
    phoneNumberFormatter,
    async paginationHandler(childPassParam) {
      this.paginationData.currentPage = childPassParam.page;
      await this.getAccountsList();    
    },

    handleResizeColumn(w, col) {
      col.width = w;
    },
    // 주요 API

    // 전체 목록 가져오기
    async getAccountsList() {
      const params = {};
      params.page = this.paginationData.currentPage;
      params.limit = this.rowsPerPage;

      try {
        const response = await this.$apiInstance.get(`/accounts/certilife`,{params});
        if(response.status === 200 || response.status === 201) {
          this.responseData = response.data.docs;
          this.listSize = response.data.totalDocs;
          this.paginationData.totalPages = response.data.totalPages;
          for (let i = 0; i < this.responseData.length; i++) {
            this.responseData[i].index =
              this.listSize - i - (this.paginationData.currentPage - 1) * this.rowsPerPage;
          }
        }
      } catch(error) {
        console.log(error);
      }
      
    },
    async handleRowsPerPage() {
      this.paginationData.currentPage = 1;
      await this.getAccountsList();
    },
    // 계정 상세
    async getAccountDetail(id) {
      try {
        const response = await this.$apiInstance.get(
        `/accounts/certilife/${id}`,
        )
        if(response.status === 200 || response.status === 201) {
          this.accountDetailData = response.data;
          this.accountDetailData.accountId = id;
        }
      } catch(error) {
        console.log(error);
      }
    },

    // 비밀번호 초기화
    async resetPassword() {
      try {
        const response = await this.$apiInstance.put(
          `/accounts/certilife/resetPassword/${this.selectedAccount}`,
        )
        if(response.status === 200 || response.status === 201) {
          await openDialog("비밀번호가 초기화되었습니다.","success", "확인")
          .then(() => {
            location.reload();
          });
        } else {
          await openDialog("비밀번호 초기화에 실패하였습니다.", "error", "확인");
        }
      } catch(error) {
        await openDialog("비밀번호 초기화에 실패하였습니다.", "error", "확인");
        console.log(error);
      }
    },

    // 계정 삭제
    async deleteAccount() {
      try {
        const response = await this.$apiInstance.delete(
          `/accounts/certilife/${this.selectedAccount}`,
          // 선택 — 적은 칸만 쿼리로(inapi 가 삭제 사유를 @Query 로 읽음). 비면 main 과 같이 아무것도 안 붙임
          { params: staffReasonFields(this.deleteReasonCode, this.deleteHrRef) }
        )
        if(response.status === 200 || response.status === 201) {
          await openDialog("해당 계정이 삭제되었습니다.","success", "확인")
          .then(() => {
            location.reload();
          });
        } else {
          await openDialog("계정 삭제에 실패하였습니다.", "error", "확인");
        }
      } catch(error) {
        console.log(error);
        await openDialog("계정 삭제에 실패하였습니다.", "error", "확인");
      }
    },



    // 기타 AccountsList용 utils

    // 보기, 수정, 삭제 시 선택
    selectAccount(accountId) {
      this.selectedAccount = accountId;
    },
  },
};
</script>
<style>
  td {
    border-bottom: 1px solid transparent !important;
  }
</style>
<style>
  td {
    border-bottom: 1px solid transparent !important;
  }
</style>